import React, { useState, useEffect, useRef } from "react"
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { debounce } from 'lodash';
import {
  Box,
} from '@material-ui/core';

const WithScale = () => {

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      console.log(window.innerWidth)
      console.log(window.innerHeight)
      let rootElemFirstChild = document.getElementById("iframeForScale")
      if (rootElemFirstChild) {
        let scaleWidth = window.innerWidth / 1600
        let scaleHeight = window.innerHeight / 2560
        if (scaleWidth >= 1 && scaleHeight >=1) {
          rootElemFirstChild.style.transform = "scale(1)"
        } else {
          let scale = Math.min(scaleWidth, scaleHeight)
          rootElemFirstChild.style.transform = "scale("+scale+")"
        }
        rootElemFirstChild.style.transformOrigin = "top left"
      }
      let rootElem = document.getElementById("root")
      if (rootElem) {
        rootElem.style.overflow = "hidden"
      }
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Helmet>
        <title>Commande | Gemini Bar</title>
      </Helmet>

      <Box>
        <iframe src="./" id="iframeForScale" style={{width:"1600px", height:"2560px", border:"0"}}></iframe>
      </Box>
    </>
  );
};

export default WithScale;
